<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" :width="computedWidth">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0 title-mobile" primary-title>
          {{ computedTitle }}
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="tipoOcorrencia.Descricao"
                  label="Descrição"
                  prepend-icon="description"
                  @keyup.enter="adiciona"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import TipoOcorrencia from '@/domain/tipoOcorrencia/TipoOcorrencia';

export default {
  name: 'ModalCadastroTipoOcorrencia',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tipoOcorrencia: {
      type: Object,
      default: () => new TipoOcorrencia()
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  computed: {
    computedTitle() {
      return this.tipoOcorrencia.IdTipoOcorrencia ? 'Editar Tipo Ocorrencia' : 'Novo Tipo Ocorrencia';
    },
    computedWidth() {
      return this.$vuetify.breakpoint.smAndDown ? '100%' : '60%';
    },
  },
  methods: {
    ...mapActions([
      'addTipoOcorrencia',
      'updateTipoOcorrencia',
    ]),
    ...mapMutations(['showNotification', 'closeNotification']),
    async adiciona() {
      if (!this.tipoOcorrencia.IdTipoOcorrencia && this.tipoOcorrencia.Descricao) {
        this.loading = true;
        const newTipoOcorrencia = Object.assign({}, this.tipoOcorrencia);
        try {
          await this.addTipoOcorrencia(newTipoOcorrencia);
          this.showNotification({ text: `Tipo Ocorrencia: ${newTipoOcorrencia.Descricao} adicionado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('tipoOcorrenciaAdicionado');
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao adicionar o tipo Ocorrencia: ${error}.`, status: 'error' });
        }
      } else if (this.tipoOcorrencia.IdTipoOcorrencia && this.tipoOcorrencia.Descricao) {
        this.loading = true;
        const updTipoOcorrencia = Object.assign({}, this.tipoOcorrencia);
        try {
          await this.updateTipoOcorrencia(updTipoOcorrencia);
          this.showNotification({ text: `Tipo Ocorrencia: ${updTipoOcorrencia.Descricao} atualizado com sucesso.`, status: 'success' });
          this.loading = false;
          this.$emit('input');
          this.$emit('tipoOcorrenciaAdicionado');
        } catch (error) {
          this.showNotification({ text: `Ocorreu um erro ao atualizar o tipo ocorrência: ${error}.`, status: 'error' });
        }
      } else {
        this.loading = false;
        this.showNotification({ text: `Informe a Descrição do tipo ocorrência.`, status: 'error' });
      }
    }
  },
}
</script>

<style scoped>
@media screen and (max-width: 480px) {
  .title-mobile {
    font-size: 1.125rem !important;
  }
}
.cursor-pointer {
  cursor: pointer;
}
</style>
